import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import axios from "axios";
import Servidor from "../config/Servidor";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export default function ListaCuentas() {
  const user = JSON.parse(localStorage.getItem("user"));
  const location = useLocation();
  const navigate = useNavigate();
const [menuFiltro, setMenuFiltro] = useState(false);
  const cobrador = location.state?.cobrador || null;

  const [cuentas, setCuentas] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [menuAbierto, setMenuAbierto] = useState(false);

  const [clientesOpen, setClientesOpen] = useState(false);
  const [listasOpen, setListasOpen] = useState(false);
  const [informacionOpen, setInformacionOpen] = useState(false);
  const [notasOpen, setNotasOpen] = useState(false);
const [seleccionados, setSeleccionados] = useState([]);
const [modalPrestamo, setModalPrestamo] = useState(false);
const [tarjetasCliente, setTarjetasCliente] = useState([]);
const [tarjetaIndex, setTarjetaIndex] = useState(0);
const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
const tarjetaActual = tarjetasCliente[tarjetaIndex];
const [modalAbonos, setModalAbonos] = useState(false);
const [tipoEliminacion, setTipoEliminacion] = useState(null);
const [idEliminar, setIdEliminar] = useState(null);
const [modalConfirmacion, setModalConfirmacion] = useState(false);
const [cuotaSeleccionada, setCuotaSeleccionada] = useState(null);
      const [modalCuota, setModalCuota] = useState(false);
      const [mensaje, setMensaje] = useState(null);
        const [clientes, setClientes] = useState([]);
        const [modalResumen, setModalResumen] = React.useState(false);
   const hoy = new Date().toISOString().split("T")[0];

const [fechaSeleccionada, setFechaSeleccionada] = useState(hoy);
useEffect(() => {
  if (!cobrador) return;

  axios
    .get(
      `${Servidor.IP}/usuarios/cuentas/${cobrador.info_usuario.id_usuario}?fecha=${fechaSeleccionada}`
    )
    .then((res) => {
      if (res.data.ok) {
        setCuentas(res.data.tarjetas || []);
      }
    })
    .catch((err) => {
      console.log(err);
      alert("Error al cargar cuentas");
    });
}, [cobrador, fechaSeleccionada]); // 👈 importante
  useEffect(() => {
    if (!cobrador) return;

    axios
      .get(`${Servidor.IP}/usuarios/cuentas/${cobrador.info_usuario.id_usuario}`)
      .then((res) => {
        if (res.data.ok) {
      setCuentas(res.data.tarjetas || []);

        }
      })
      .catch((err) => {
        console.log(err);
        alert("Error al cargar cuentas");
      });
  }, [cobrador]);

useEffect(() => {
  const ruta = location.pathname;

  // CLIENTES
  if (
    ruta === "/listaclientes" ||
    ruta === "/listacuentas" ||
    ruta === "/listadesactivados" ||
    ruta === "/listaeliminarcliente" ||
    ruta === "/listaeliminarcuenta"
  ) {
    setClientesOpen(true);
  }

  // LISTAS PERSONALIZADAS
  if (ruta === "/listaspersonalizadas") {
    setListasOpen(true);
  }

  // INFORMACION COBRO
  if (
    ruta === "/reportediario" ||
    ruta === "/ultimolugarregistrado" ||
    ruta === "/posicionclientes" ||
    ruta === "/enviarmensaje"
  ) {
    setInformacionOpen(true);
  }

  // NOTAS
  if (
    ruta === "/notascobro" ||
    ruta === "/notascobrosocio"
  ) {
    setNotasOpen(true);
  }

}, [location.pathname]);

const descargarPDF = () => {

  const confirmar = window.confirm("¿Confirmar descarga del PDF?");
  if (!confirmar) return;

  const doc = new jsPDF("p", "mm", "a4");

  // 📅 Fecha actual
  const ahora = new Date();
  const dia = String(ahora.getDate()).padStart(2, "0");
  const mes = String(ahora.getMonth() + 1).padStart(2, "0");
  const anioCompleto = ahora.getFullYear();
  const anioCorto = String(anioCompleto).slice(-2);

  const hora = ahora.toLocaleTimeString();

  const nombreArchivo = `${dia}-${mes}-${anioCorto}.pdf`;

  // 🏷️ TITULO
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.text("LISTA DE CUENTAS", 105, 15, { align: "center" });

  doc.setFontSize(11);
  doc.setFont("helvetica", "normal");

  // 👤 Nombre supervisado (IZQUIERDA)
const nombreSupervisado =
  `${cobrador.persona?.nombre || ""} ${cobrador.persona?.primerapellido || ""}`;

  doc.text(
    `De: ${nombreSupervisado}`,
    14,
    25
  );

// 👔 Supervisor (DERECHA) dinámico
const nombreSupervisor =
  user.persona_nombre && user.persona_apellido
    ? `${user.persona_nombre} ${user.persona_apellido}`
    : user.persona_nombre || user.usuario;

doc.text(
  `Supervisor: ${nombreSupervisor}`,
  196,
  25,
  { align: "right" }
);

  // 📅 Fecha con hora ARRIBA DERECHA
  doc.setFontSize(9);
  doc.text(
    `Fecha: ${dia}/${mes}/${anioCompleto} - ${hora}`,
    196,
    10,
    { align: "right" }
  );

  // 📊 Columnas
  const columnas = [
    "Cliente",
    "Fecha",
    "Fecha Terminar",
    "Valor",
    "Cuotas",
    "Cts Pagadas",
    "Dias Atrasados",
    "Deuda",
    "Sin Liquidar"
  ];

  // 📄 Filas SIN Bs. y SIN hora
  const filas = cuentasFiltradas.map(ct => [
    ct.cliente,
    formatFecha(ct.fechainicial),
    formatFecha(ct.fechafinal),
    Number(ct.valor).toLocaleString("es-BO"),
    ct.ncuotas,
    ct.cuotas_pagadas,
    ct.diasatrazo,
    Number(ct.deudaactual).toLocaleString("es-BO"),
    Number(ct.sinliquidar).toLocaleString("es-BO")
  ]);

  autoTable(doc, {
    startY: 35,
    head: [columnas],
    body: filas,
    styles: { fontSize: 8 },
    headStyles: { fillColor: [7, 64, 160] }
  });

  doc.save(nombreArchivo);
};
const abrirResumenCliente = (cliente) => {
    setClienteSeleccionado({
        nombreCliente: cliente?.cliente || "Cliente",
        cedula: cliente?.cedula || ""
      });// guardamos los datos del cliente
  setModalResumen(true);           // abrimos el modal
};
const formatFechaHora = (fecha) => {
  const d = new Date(fecha);

  const pad = (n) => n.toString().padStart(2, '0');

  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
const formatFecha = (fecha) => {
  const d = new Date(fecha);

  const pad = (n) => n.toString().padStart(2, '0');

  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} `;
};
  if (!cobrador) {
    return (
      <div style={{ padding: 20 }}>
        <h2 style={{ color: "red" }}>⚠ No se recibió el cobrador.</h2>
        <button
          onClick={() => navigate("/principal")}
          style={{
            padding: 10,
            borderRadius: 6,
            background: "#0740A0",
            color: "white",
            border: "none",
          }}
        >
          Volver al inicio
        </button>
      </div>
    );
  }

const cuentasUnicas = Object.values(
  (cuentas || []).reduce((acc, item) => {
    const key = item.id_cliente || item.cliente; // mejor usar id_cliente si existe

    if (!acc[key]) {
      acc[key] = item;
    } else {
      // Comparar fechas y quedarse con la más reciente
      const fechaActual = new Date(item.fechainicial);
      const fechaGuardada = new Date(acc[key].fechainicial);

      if (fechaActual > fechaGuardada) {
        acc[key] = item;
      }
    }

    return acc;
  }, {})
);

const cuentasFiltradas = cuentasUnicas.filter((c) =>
  JSON.stringify(c).toLowerCase().includes(busqueda.toLowerCase())
);

// 🔴 Marcador rojo
const marcadorRojo = new L.Icon({
  iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});
const recargarTarjetaActual = async () => {
  try {
    const response = await fetch(
      `${Servidor.IP}/clientes/tarjetas/${clienteSeleccionado.id_cliente}`
    );

    const data = await response.json();

    if (data.ok) {

      // Buscar la tarjeta actualizada por ID
      const tarjetaActualizada = data.tarjetas.find(
        t => t.id_tarjeta === tarjetasCliente[tarjetaIndex].id_tarjeta
      );

      if (!tarjetaActualizada) return;

      setTarjetasCliente(prev =>
        prev.map((t, index) =>
          index === tarjetaIndex ? tarjetaActualizada : t
        )
      );
    }

  } catch (error) {
    console.error("Error recargando tarjeta actual:", error);
  }
};
const eliminarCliente = async (id) => {
  try {
    const response = await fetch(`${Servidor.IP}/eliminarcliente/${id}`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    });

    const data = await response.json();

    if (!response.ok) {
      setMensaje({ tipo: "error", texto: data.error || "No se pudo eliminar." });
      setTimeout(() => setMensaje(null), 3000);
      return;
    }

    setMensaje({ tipo: "success", texto: "Cliente eliminado correctamente." });
  setTimeout(() => {
  setMensaje(null);
  setClientes(prev => prev.filter(c => c.id_cliente !== id));
}, 800);

  } catch (error) {
    console.error("Error eliminando cliente:", error);
    setMensaje({ tipo: "error", texto: "Ocurrió un error." });
    setTimeout(() => setMensaje(null), 3000);
  }
};
const eliminarTarjeta = async (id) => {
  try {
    const response = await fetch(`${Servidor.IP}/eliminartarjeta/${id}`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    });

    const data = await response.json();

    if (!response.ok) {
      setMensaje({ tipo: "error", texto: data.error || "No se pudo eliminar la tarjeta." });
      setTimeout(() => setMensaje(null), 3000);
      return;
    }

    // ✅ ELIMINA DEL ESTADO (ESTO REEMPLAZA EL RELOAD)
    setTarjetasCliente(prev =>
      prev.filter(t => t.id_tarjeta !== id)
    );

    setMensaje({ tipo: "success", texto: "Tarjeta eliminada correctamente." });

    setTimeout(() => {
      setMensaje(null);

      // Si ya no quedan tarjetas, cerramos el modal
      if (tarjetasCliente.length === 1) {
        setModalPrestamo(false);
      } else {
        setTarjetaIndex(0); // vuelve a la primera
      }

    }, 800);

  } catch (error) {
    console.error("Error eliminando tarjeta:", error);
    setMensaje({ tipo: "error", texto: "Ocurrió un error al eliminar la tarjeta." });
    setTimeout(() => setMensaje(null), 3000);
  }
};
const eliminarCobro = async (id) => {
  try {
    const response = await fetch(`${Servidor.IP}/eliminarcobro/${id}`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    });

    const data = await response.json();

    if (!response.ok) {
      setMensaje({
        tipo: "error",
        texto: data.error || "No se pudo eliminar el cobro.",
      });
      setTimeout(() => setMensaje(null), 3000);
      return;
    }

    // 🔥 Recargar SOLO las tarjetas del cliente actual
  await recargarTarjetaActual();

    setMensaje({
      tipo: "success",
      texto: "Cobro eliminado correctamente.",
    });

    setTimeout(() => setMensaje(null), 1500);

  } catch (error) {
    console.error("Error eliminando cobro:", error);

    setMensaje({
      tipo: "error",
      texto: "Ocurrió un error al eliminar el cobro.",
    });

    setTimeout(() => setMensaje(null), 3000);
  }
};

const eliminarAbono = async (id) => {
  try {
    const response = await fetch(`${Servidor.IP}/eliminarabono/${id}`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    });

    const data = await response.json();

    if (!response.ok) {
      setMensaje({
        tipo: "error",
        texto: data.error || "No se pudo eliminar el abono.",
      });
      setTimeout(() => setMensaje(null), 3000);
      return;
    }

    // 🔥 Recargar SOLO las tarjetas del cliente actual
 await recargarTarjetaActual();

    setMensaje({
      tipo: "success",
      texto: "Abono eliminado correctamente.",
    });

    setTimeout(() => setMensaje(null), 1500);

  } catch (error) {
    console.error("Error eliminando abono:", error);

    setMensaje({
      tipo: "error",
      texto: "Ocurrió un error al eliminar el abono.",
    });

    setTimeout(() => setMensaje(null), 3000);
  }
};
const Fila = ({ label, value }) => (
  <tr>
    <td style={{ border: "1px solid #ddd", padding: 8, fontWeight: "bold" }}>
      {label}
    </td>
    <td style={{ border: "1px solid #ddd", padding: 8, textAlign: "right" }}>
      {value}
    </td>
  </tr>
);

const Casilla = ({ numero, onClick }) => (
  <div
    onClick={onClick}
    style={{
      width: 48,
      height: 48,
      border: "1px solid #000",
      borderRadius: 6,
      overflow: "hidden",
      fontSize: 11,
      cursor: "pointer"
    }}
  >


    {/* Parte superior plomo oscuro */}
    <div
      style={{
        background: "#191538", // plomo oscuro
        flex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontWeight: "bold",
        color: "#fff",
         fontSize: 14,
      }}
    >
      {numero}
    </div>

    {/* Parte inferior plomo claro */}
    <div
      style={{
        background: "#ffffff", // plomo más claro
        flex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
         fontSize: 14,
      
      }}
    >
      Abono
    </div>
  </div>
);

  //CONFIRMAR ELIMINAR
  const confirmarEliminacion = (tipo, id) => {
  setTipoEliminacion(tipo); // "abono" | "cobro" | "tarjeta"
  setIdEliminar(id);
  setModalConfirmacion(true);
};
//mapa del cobro
const abrirModalCuota = (cuota) => {
  setCuotaSeleccionada(cuota);
  setModalCuota(true);
};
const CasillaCuota = ({
  numero,
  fecha,
  latCobro,
  lngCobro,
  latTarjeta,
  lngTarjeta,
  onClick
}) => {

  const dia = new Date(fecha);

  const semana = Math.floor(dia.getDate() / 7);
  const colorFecha = semana % 2 === 0 ? "#f7f73c" : "#0085f1";

 const distancia =
    latCobro && lngCobro && latTarjeta && lngTarjeta
      ? Math.sqrt(
          Math.pow(latCobro - latTarjeta, 2) +
          Math.pow(lngCobro - lngTarjeta, 2)
        ) * 111139
      : 0;

  const colorNumero = distancia <= 5 ? "#00ff3c" : "#ff0000";

return (
  <div
    onClick={onClick}
    style={{
      width: 48,
      height: 48,
      border: "1px solid #000",
      borderRadius: 6,
      overflow: "hidden",
      fontSize: 11,
      cursor: "pointer"
    }}
  >

      <div
        style={{
          background: colorNumero,
          textAlign: "center",
              display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontWeight: "bold",
          height: "55%",
          fontSize: 14,
            color: "#fff",
        }}
      >
        {numero}
      </div>

      <div
        style={{
          background: colorFecha,
          textAlign: "center",
              display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontWeight: "bold",
          height: "45%",
          fontSize: 14
        }}
      >
        {dia.toLocaleDateString("es-ES", {
          day: "2-digit",
          month: "2-digit"
        })}
      </div>
    </div>
  );
};

const anteriorTarjeta = () => {
  if (tarjetaIndex > 0) {
    setTarjetaIndex(tarjetaIndex - 1);
  }
};

const siguienteTarjeta = () => {
  if (tarjetaIndex < tarjetasCliente.length - 1) {
    setTarjetaIndex(tarjetaIndex + 1);
  }
};
const formatearFecha = (fecha) => {
  return new Date(fecha).toLocaleString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
};
const toggleSeleccion = (id) => {
  if (seleccionados.includes(id)) {
    setSeleccionados(seleccionados.filter((x) => x !== id));
  } else {
    setSeleccionados([...seleccionados, id]);
  }
};
const seleccionarTodos = () => {
  if (seleccionados.length === cuentasFiltradas.length) {
    setSeleccionados([]);
  } else {
    setSeleccionados(cuentasFiltradas.map((c) => c.id_tarjeta));
  }
};
const abrirModalPrestamo = async (cliente) => {
setClienteSeleccionado({
  nombreCliente: (cliente?.cliente || "Cliente").split(" ")[0],
  cedula: cliente?.cedula || ""
});
  setModalPrestamo(true);
  setTarjetaIndex(0);



  try {
    const res = await axios.get(
      `${Servidor.IP}/usuarios/cuentas/${cobrador.info_usuario.id_usuario}`
    );

    if (res.data.ok) {
      // 🔥 filtrar tarjetas SOLO del cliente
      /*  ESTE ES ACTIVOS Y INACTIVOS
   const tarjetasDelCliente = res.data.tarjetas
  .filter(t => t.id_cliente === cliente.id_cliente)
  .sort((a, b) => b.activo - a.activo); // 🔥 activas primero

setTarjetasCliente(tarjetasDelCliente);
*/
 const tarjetasDelCliente = res.data.tarjetas.filter(
  t => t.id_cliente === cliente.id_cliente && t.activo === 1
);

setTarjetasCliente(tarjetasDelCliente);
setTarjetaIndex(0);
    }
  } catch (error) {
    console.error("Error cargando tarjetas", error);
    setTarjetasCliente([]);
  }
};
const abrirModalTarjeta = async (id_cliente, id_tarjeta) => {
  try {
    const response = await axios.get(
      `${Servidor.IP}/clientes/tarjetas/${id_cliente}`
    );

    if (response.data.ok) {
      const tarjetas = response.data.tarjetas;

      setTarjetasCliente(tarjetas);

      // 🔥 BUSCAR LA TARJETA CLICKEADA
      const index = tarjetas.findIndex(
        (t) => t.id_tarjeta === id_tarjeta
      );

      setTarjetaIndex(index >= 0 ? index : 0);

      // 🔥 SETEAR CLIENTE SELECCIONADO (AQUÍ ESTABA EL ERROR)
      const cliente = cuentas.find(
        (c) => c.id_cliente === id_cliente
      );

      setClienteSeleccionado({
        nombreCliente: cliente?.cliente || "Cliente",
        cedula: cliente?.cedula || ""
      });

      setModalPrestamo(true);
    }

  } catch (error) {
    console.log("Error cargando tarjetas:", error);
  }
};
  return (
    <div style={{ padding: 10 }}>
     {/* NAV SUPERIOR RESPONSIVE */}
<div
  style={{
    width: "100%",
    maxWidth: "100%",
    background: "#0740A0",
    color: "white",
    padding: "12px 16px",
    borderRadius: "8px",
    marginBottom: "20px",
    boxSizing: "border-box",
    overflow: "hidden",
    wordWrap: "break-word",
  }}
>
  <h2
    style={{
      margin: 0,
      fontSize: "clamp(16px, 4vw, 20px)", // Se ajusta según pantalla
      fontWeight: "bold",
      lineHeight: 1.2,
    }}
  >
     
         Supervisando a  {cobrador.persona?.nombre || cobrador.info_usuario.usuario}
  </h2>
  <h2
    style={{
    margin: 0,
    fontSize: "clamp(16px, 4vw, 20px)",
    fontWeight: "bold",
    lineHeight: 1.2,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  }}
  >
    
      {/* BOTÓN MENU */}
      <button
        onClick={() => setMenuAbierto(true)}
        style={{
          fontSize: 25,
          padding: 8,
          border: "none",
           background: "#0740A0",
    color: "white",
          cursor: "pointer",
        }}
      >
        ☰
      </button>
       <span>{user.persona_nombre || user.usuario}</span>
           <button
    onClick={() => setMenuFiltro(true)}
    style={{
      fontSize: 22,
      background: "none",
      border: "none",
      color: "white",
      cursor: "pointer",
    }}
  >
    ⋮
  </button>
  </h2>
  <p
    style={{
      margin: "4px 0 0 0",
      fontSize: "clamp(12px, 3vw, 15px)", // También responsivo
      opacity: 0.95,
      lineHeight: 1.2,
    }}
  >
    
  </p>
</div>
      {/* MENU LATERAL */}
      {menuAbierto && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100%",
            width: "100%",
            background: "rgba(0,0,0,0.4)",
            backdropFilter: "blur(2px)",
            zIndex: 999,
          }}
          onClick={() => setMenuAbierto(false)}
        >
          <div
            style={{
              width: 250,
              height: "100%",
              background: "white",
              padding: 20,
              boxShadow: "3px 0 10px rgba(0,0,0,0.3)",
              overflowY: "auto",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h2 style={{ marginTop: 0 }}>Menú</h2>

      {/* CLIENTES */}
<p
  style={{ cursor: "pointer", fontWeight: "bold" }}
  onClick={() => setClientesOpen(!clientesOpen)}
>
  👥 Clientes {clientesOpen ? "🔼" : "🔽"}
</p>

{clientesOpen && (
  <div style={{ paddingLeft: 20 }}>
    <p onClick={() => navigate("/listaclientes", { state: { cobrador } })}>
      📋 Listado de clientes
    </p>
    <p  style={{
    cursor: "pointer",
    backgroundColor: "#1e40af", // azul
    color: "#ffffff",
    padding: "8px 12px",
    borderRadius: "10px",
    width: "fit-content",
    margin: "6px 0"
  }} >
      💳 Listado de cuentas
    </p>
    <p style={{ cursor: "pointer" }} onClick={() => navigate("/listadesactivados", { state: { cobrador } })}>
      ⛔ Clientes desactivados
    </p>
    <p style={{ cursor: "pointer" }} onClick={() => navigate("/listaeliminarcliente", { state: { cobrador } })}>
      ✅ Aprobar eliminación de cliente
    </p>
    <p style={{ cursor: "pointer" }} onClick={() => navigate("/listaeliminarcuenta", { state: { cobrador } })}>
      🗑️ Aprobar eliminación de cuenta
    </p>
  </div>
)}

{/* LISTAS PERSONALIZADAS */}
<p
  style={{ cursor: "pointer", fontWeight: "bold" }}
  onClick={() => setListasOpen(!listasOpen)}
>
  🗂️ Listas personalizadas {listasOpen ? "🔼" : "🔽"}
</p>

{listasOpen && (
  <div style={{ paddingLeft: 20 }}>
    <p style={{ cursor: "pointer" }}   onClick={() => navigate("/listaspersonalizadas", { state: { cobrador } })}>
      📑 Ver listas personalizadas
    </p>
  </div>
)}

<p style={{ cursor: "pointer" }}   onClick={() => navigate("/filtroclientes", { state: { cobrador } })}>
  🔍 Filtros de clientes
</p>

{/* INFORMACIÓN COBRO */}
<p
  style={{ cursor: "pointer", fontWeight: "bold" }}
  onClick={() => setInformacionOpen(!informacionOpen)}
>
  💰 Información de cobro {informacionOpen ? "🔼" : "🔽"}
</p>

{informacionOpen && (
  <div style={{ paddingLeft: 20 }}>
    <p  style={{ cursor: "pointer" }} onClick={() => navigate("/reportediario", { state: { cobrador } })}>
      📊 Reporte diario
    </p>
    <p style={{ cursor: "pointer" }}   onClick={() => navigate("/ultimolugarregistrado", { state: { cobrador } })}>
      📍 Último lugar registrado
    </p>
    <p style={{ cursor: "pointer" }}   onClick={() => navigate("/posicionclientes", { state: { cobrador } })}>
      🧭 Posición de clientes
    </p>
    <p style={{ cursor: "pointer" }}   onClick={() => navigate("/enviarmensaje", { state: { cobrador } })}>
      ✉️ Enviar mensaje
    </p>
  </div>
)}

{/* NOTAS */}
<p
  style={{ cursor: "pointer", fontWeight: "bold" }}
  onClick={() => setNotasOpen(!notasOpen)}
>
  📝 Notas {notasOpen ? "🔼" : "🔽"}
</p>

{notasOpen && (
  <div style={{ paddingLeft: 20 }}>
    <p style={{ cursor: "pointer" }}   onClick={() => navigate("/notascobro", { state: { cobrador } })}>
      🗒️ Notas de cobro
    </p>
    <p style={{ cursor: "pointer" }}   onClick={() => navigate("/notascobrosocio", { state: { cobrador } })}>
      🤝 Notas de cobro socio
    </p>
  </div>
)}

<p style={{ cursor: "pointer" }}   onClick={() => navigate("/nuevaliquidacion", { state: { cobrador } })}>
  💵 Nueva liquidación
</p>

<p style={{ cursor: "pointer" }}   onClick={() => navigate("/listaliquidadas", { state: { cobrador } })}>
  📃 Lista de liquidadas
</p>

<p style={{ cursor: "pointer" }}   onClick={() => navigate("/solicitudmodificarcliente", { state: { cobrador } })}>
  ✏️ Solicitud modificar cliente
</p>

<p style={{ cursor: "pointer" }}   onClick={() => navigate("/solicitudgastos", { state: { cobrador } })}>
  🧾 Solicitud de gastos
</p>


       <p style={{ cursor: "pointer", fontWeight: "bold" ,color:"white"}}>
             final menu
              </p>
          </div>
        </div>
      )}
{/* MODAL DE LOS 3 PUNTOS  */}
{menuFiltro && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.4)",
      backdropFilter: "blur(2px)",
      zIndex: 1000,
    }}
    onClick={() => setMenuFiltro(false)} // clic fuera cierra
  >
    <div
      style={{
        position: "absolute",
        top: 50,        // ajuste: bajo el header
        right: 16,      // ajuste: al fondo derecha
        background: "white",
        borderRadius: 8,
        padding: 12,
        width: 230,
        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
      }}
      onClick={(e) => e.stopPropagation()} // evita cerrar al tocar dentro
    >
   <label
  onClick={descargarPDF}
  style={{ display: "block", cursor: "pointer", padding: 8 }}
>
  📄 Descargar PDF
</label>


   
    </div>
  </div>
)}
   {/* 🔍 BUSCADOR (NO SE SALE DE LA PANTALLA) */}
      <input
        type="text"
        placeholder="Buscar cliente..."
        value={busqueda}
        onChange={(e) => setBusqueda(e.target.value)}
        style={{
          width: "100%",
          maxWidth: "100%",
          padding: 8,
          fontSize: 15,
          borderRadius: 5,
          border: "1px solid #ccc",
          marginBottom: 12,
          boxSizing: "border-box",
        }}
      />
          {/* TABLA SCROLLEABLE SOLO HASTA EL ANCHO REAL */}
      <div
        style={{
          overflowX: "auto",
          borderRadius: 6,
          border: "1px solid #ddd",
          paddingBottom: 5,
        }}
      >
      {/* TABLA */}
    <div
  style={{
    maxHeight: "65vh",
    overflowY: "auto",
    overflowX: "auto",
    border: "1px solid #ddd",
    borderRadius: 8,
  }}
>
  <table
    style={{
      width: "100%",
      minWidth: "900px",
      borderCollapse: "collapse",
      background: "white",
    }}
  >
    <thead
      style={{
        position: "sticky",
        top: 0,
        background: "#0740A0",
        color: "white",
        zIndex: 2,
      }}
    >
            <tr>
              <th style={th}>
  <input
    type="checkbox"
    onChange={seleccionarTodos}
    checked={
      cuentasFiltradas.length > 0 &&
      seleccionados.length === cuentasFiltradas.length
    }
  />
</th>
              <th style={th}>Cliente</th>
              <th style={th}>Fecha</th>
              <th style={th}>Fecha Terminar</th>
              <th style={th}>Valor</th>
              <th style={th}>Cuotas</th>
               <th style={th}>Cts Pagadas</th>
                <th style={th}>Dias Atrasados</th>
                <th style={th}>Deuda</th>
                 <th style={th}>Sin Liquidar</th>
                   <th style={th}>
  <div style={{ display: "flex", flexDirection: "column" }}>
    <span>Pago en Fecha</span>
    <input
      type="date"
      value={fechaSeleccionada}
      onChange={(e) => setFechaSeleccionada(e.target.value)}
      style={{
        marginTop: 4,
        padding: 4,
        fontSize: 12,
        borderRadius: 4,
        border: "none"
      }}
    />
  </div>
</th>
              <th style={th}></th>
            </tr>
          </thead>

          <tbody>
           {cuentasFiltradas.map((ct) => {
  
  // 🎨 COLOR FILA SEGÚN ESTADO
  let rowStyle = { ...tr }; 



  // FORMATEAR EN Bs.
  const bs = (n) =>
    "Bs. " + Number(n).toLocaleString("es-BO", { minimumFractionDigits: 2 });

  return (
 <tr
  key={ct.id_tarjeta}
  onClick={() => abrirModalPrestamo(ct)}
  style={{
    ...tr,
    cursor: "pointer",
    backgroundColor: seleccionados.includes(ct.id_tarjeta)
      ? "#E6F0FF"
      : "white",
  }}
>
    <td style={td}>
 <input
  type="checkbox"
  checked={seleccionados.includes(ct.id_tarjeta)}
  onChange={() => toggleSeleccion(ct.id_tarjeta)}
  onClick={(e) => e.stopPropagation()} // evita que suba el clic al tr o td
/>
</td>

     <td style={td}>
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 10,
    }}
  >
    <span>{ct.cliente}</span>

  <button
  style={btn1}
  onClick={(e) => {
    e.stopPropagation();
    abrirResumenCliente(ct);
  }}>
  🔍
</button>
  </div>
</td>

<td style={td}>{formatFechaHora(ct.fechainicial)}</td>
<td style={td}>{formatFecha(ct.fechafinal)}</td>


      <td style={td}>{bs(ct.valor)}</td>

    <td>{ct.ncuotas}</td> 
      <td style={td}>{ct.cuotas_pagadas}</td>

 <td style={td}>{ct.diasatrazo < 0 ? 0 : ct.diasatrazo}</td>

      <td style={td}>{bs(ct.deudaactual)}</td>

      <td style={td}>{bs(ct.sinliquidar)}</td>
<td style={td}>{bs(ct.pagoenfecha)}</td>
    </tr>
  );
})}

          </tbody>
        </table>
      </div>
{/* MODAL RESUMEN */}
{modalResumen && clienteSeleccionado && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.4)",
      zIndex: 2000,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
    onClick={() => setModalResumen(false)}
  >
    <div
      style={{
        background: "white",
        borderRadius: 8,
        width: "90%",
        maxWidth: 700,
        maxHeight: "80%",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
      }}
      onClick={(e) => e.stopPropagation()} // evita cerrar al hacer click dentro
    >
      {/* Encabezado */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 15px",
          backgroundColor: "#0740A0",
          color: "white",
          fontWeight: "bold",
          fontSize: 16,
        }}
      >
        <span>Resumen de {clienteSeleccionado.nombreCliente}</span>
        <button
          onClick={() => setModalResumen(false)}
          style={{
            background: "transparent",
            border: "none",
            color: "white",
            fontSize: 18,
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          ✕
        </button>
      </div>

      {/* Contenido interno como tablas */}
      <div style={{ padding: 15, fontSize: 14, display: "flex", flexDirection: "column", gap: 16 }}>
        {/* Tabla resumen */}
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <tbody>
            <tr>
              <td style={{ border: "1px solid #ddd", padding: 8 }}>Días para visitar</td>
              <td style={{ border: "1px solid #ddd", padding: 8, textAlign: "right" }}>
                {clienteSeleccionado.diasParaVisitar || 1}
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #ddd", padding: 8 }}>Días visitados</td>
              <td style={{ border: "1px solid #ddd", padding: 8, textAlign: "right" }}>
                {clienteSeleccionado.diasVisitados || 0}
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #ddd", padding: 8 }}>Debió pagar</td>
              <td style={{ border: "1px solid #ddd", padding: 8, textAlign: "right" }}>
                {clienteSeleccionado.valorDebioPagar || "Bs. 100"}
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #ddd", padding: 8 }}>Pago</td>
              <td style={{ border: "1px solid #ddd", padding: 8, textAlign: "right" }}>
                {clienteSeleccionado.valorPago || "Bs. 0"}
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #ddd", padding: 8 }}>Préstamos a terminar</td>
              <td style={{ border: "1px solid #ddd", padding: 8, textAlign: "right" }}>
                {clienteSeleccionado.prestamosATerminar || 1}
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #ddd", padding: 8 }}>Préstamos terminados</td>
              <td style={{ border: "1px solid #ddd", padding: 8, textAlign: "right" }}>
                {clienteSeleccionado.prestamosTerminados || 0}
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #ddd", padding: 8 }}>Préstamos nuevos</td>
              <td style={{ border: "1px solid #ddd", padding: 8, textAlign: "right" }}>
                {clienteSeleccionado.prestamosNuevos || 0}
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #ddd", padding: 8 }}>Valor préstamos nuevos</td>
              <td style={{ border: "1px solid #ddd", padding: 8, textAlign: "right" }}>
                {clienteSeleccionado.valorPrestamosNuevos || "Bs. 0"}
              </td>
            </tr>
          </tbody>
        </table>

        {/* Novedades */}
        <div style={{ borderTop: "1px solid #ddd", paddingTop: 10 }}>
          <div style={{ fontWeight: "bold", marginBottom: 8 }}>Novedades</div>
          {clienteSeleccionado.novedades && clienteSeleccionado.novedades.length > 0 ? (
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th style={{ textAlign: "left", borderBottom: "1px solid #ddd", padding: 6 }}>Fecha</th>
                  <th style={{ textAlign: "left", borderBottom: "1px solid #ddd", padding: 6 }}>Detalle</th>
                  <th style={{ textAlign: "left", borderBottom: "1px solid #ddd", padding: 6 }}>Revisador</th>
                </tr>
              </thead>
              <tbody>
                {clienteSeleccionado.novedades.map((nov, idx) => (
                  <tr key={idx}>
                    <td style={{ padding: 6, borderBottom: "1px solid #eee" }}>{"nov.fecha"}</td>
                    <td style={{ padding: 6, borderBottom: "1px solid #eee" }}>{"nov.detalle"}</td>
                    <td style={{ padding: 6, borderBottom: "1px solid #eee" }}>{"nov.revisador"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div style={{ padding: 10, color: "#555" }}>No tiene novedades registradas</div>
          )}
        </div>
      </div>
    </div>
  </div>
)}

      {/* MODAL UBICACIÓN COBRO */}
      {modalCuota && cuotaSeleccionada && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.4)",
            zIndex: 4000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={() => setModalCuota(false)}
        >
          <div
            style={{
              background: "white",
              borderRadius: 8,
              width: "80%",
              maxWidth: 600,
              height: 400,
              position: "relative",
              boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* HEADER */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px 15px",
                backgroundColor: "#0740A0",
                color: "white",
                fontWeight: "bold",
                fontSize: 16,
              }}
            >
              <span>
                Ubicación del cobro #{cuotaSeleccionada.numero}
              </span>
      
              <button
                onClick={() => setModalCuota(false)}
                style={{
                  background: "transparent",
                  border: "none",
                  color: "white",
                  fontSize: 18,
                  cursor: "pointer",
                  fontWeight: "bold",
                }}
              >
                ✕
              </button>
            </div>
      
            {/* MAPA */}
           {cuotaSeleccionada.latitud && cuotaSeleccionada.longitud ? (
                 <MapContainer
                   center={[
                     cuotaSeleccionada.latitud,
                     cuotaSeleccionada.longitud,
                   ]}
                   zoom={17}
                   style={{ flex: 1, width: "100%" }}
                 >
                   <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
         
                   <Marker
                     position={[
                       cuotaSeleccionada.latitud,
                       cuotaSeleccionada.longitud,
                     ]}
                     icon={marcadorRojo}
                   />
                 </MapContainer>
               ) : (
                 <p style={{ padding: 20 }}>
                   Este cobro no tiene ubicación registrada.
                 </p>
               )}
             </div>
           </div>
         )}
      {/* MODAL VER ABONOS */}
{modalAbonos && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.4)",
      zIndex: 3000,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
    onClick={() => setModalAbonos(false)}
  >
    <div
      style={{
        background: "white",
        borderRadius: 8,
        width: "90%",
        maxWidth: 500,
        maxHeight: "80%",
        overflowY: "auto",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* HEADER */}
      <div
        style={{
          padding: 12,
          background: "#0740A0",
          color: "white",
          fontWeight: "bold",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <span>Abonos</span>
        <button
          onClick={() => setModalAbonos(false)}
          style={{
            background: "none",
            border: "none",
            color: "white",
            fontSize: 18,
            cursor: "pointer",
          }}
        >
          ✕
        </button>
      </div>

      {/* LISTA */}
     {/* LISTA DE ABONOS REALES */}
{/* ===== LISTA DE ABONOS ===== */}
<div style={{ padding: 15 }}>

  {/* ENCABEZADO */}
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "1fr 1fr 40px",
      fontWeight: "bold",
      borderBottom: "2px solid #000",
      paddingBottom: 6,
      marginBottom: 6,
      fontSize: 13
    }}
  >
    <div>Fecha</div>
    <div style={{ textAlign: "right" }}>Valor</div>
    <div></div>
  </div>

  {/* CONTENEDOR CON SCROLL */}
  <div
    style={{
      maxHeight: 260,
      overflowY: "auto",
      paddingRight: 4
    }}
  >
    {tarjetaActual?.abonos?.length > 0 ? (
      tarjetaActual.abonos.map((abono, i, arr) => (
        <div
          key={abono.id_abono}
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 40px",
            alignItems: "center",
            padding: "6px 0",
            borderBottom: "1px solid #eee",
            fontSize: 12
          }}
        >
          {/* FECHA */}
          <div style={{fontWeight: "bold",  fontSize: 14 }}>
            {new Date(abono.fecha).toLocaleDateString("es-ES", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit"
            })}
          </div>

          {/* VALOR */}
          <div style={{ textAlign: "right", fontWeight: "bold",  fontSize: 14 }}>
            Bs. {Number(abono.monto).toFixed(2)}
          </div>

          {/* 🗑️ SOLO EL ÚLTIMO */}
          <div style={{ textAlign: "center" }}>
            {i === arr.length - 1 && (
              <button
                onClick={() => confirmarEliminacion("abono", abono.id_abono)}

                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  color: "red",
                  fontSize: 16
                }}
              >
                🗑️
              </button>
            )}
          </div>
        </div>
      ))
    ) : (
      <div style={{ textAlign: "center", padding: 15, color: "#666" }}>
        No hay abonos registrados
      </div>
    )}
  </div>
</div>


    </div>
  </div>
)}
      {/* MODAL CONFIRMACION ELIMINACION */}
{modalConfirmacion && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.4)",
      zIndex: 5000,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
    onClick={() => setModalConfirmacion(false)}
  >
    <div
      style={{
        background: "white",
        borderRadius: 8,
        width: 320,
        padding: 20,
        boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
        textAlign: "center",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <h3 style={{ marginTop: 0, color: "#b00020" }}>
        ¿Está seguro que desea eliminar?
      </h3>

      <p style={{ fontSize: 14 }}>
        Esta acción no se puede deshacer.
      </p>

      <div style={{ marginTop: 20, display: "flex", justifyContent: "space-around" }}>
        <button
          onClick={() => setModalConfirmacion(false)}
          style={{
            padding: "6px 16px",
            borderRadius: 6,
            border: "1px solid #ccc",
            background: "#f5f5f5",
            cursor: "pointer",
          }}
        >
          NO
        </button>

     <button
  onClick={() => {
    if (tipoEliminacion === "cliente") {
      eliminarCliente(idEliminar);
    }

    if (tipoEliminacion === "tarjeta") {
      eliminarTarjeta(idEliminar);
    }

    if (tipoEliminacion === "cobro") {
      eliminarCobro(idEliminar);
    }

    if (tipoEliminacion === "abono") {
      eliminarAbono(idEliminar);
    }

    setModalConfirmacion(false);
  }}
  style={{
    padding: "6px 16px",
    borderRadius: 6,
    border: "none",
    background: "#d32f2f",
    color: "white",
    cursor: "pointer",
  }}
>
  SI
</button>

      </div>
    </div>
  </div>
)}
  {/**MODAL DE TARJETAS CLIENTE */}
 {modalPrestamo && clienteSeleccionado && (

  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.4)",
      zIndex: 2000,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
    onClick={() => setModalPrestamo(false)}
  >
    <div
      style={{
        background: "white",
        borderRadius: 8,
        width: "90%",
        maxWidth: 700,
        maxHeight: "80%",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* Encabezado */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 15px",
          backgroundColor: "#0740A0",
          color: "white",
          fontWeight: "bold",
          fontSize: 16,
        }}
      >
    <span>
  Préstamo de {clienteSeleccionado.nombreCliente}
  <br />
  <small style={{ fontWeight: "normal" }}>
    Tarjeta {tarjetaIndex + 1} de {tarjetasCliente.length}
    {tarjetasCliente[tarjetaIndex]?.activo === 1 ? " (Activa)" : " (Inactiva)"}
  </small>
</span>

        <div>
          <button
            onClick={anteriorTarjeta}
            disabled={tarjetaIndex === 0}
            style={{
              background: "transparent",
              border: "none",
              color: "white",
              fontSize: 20,
              cursor: tarjetaIndex === 0 ? "not-allowed" : "pointer",
              marginRight: 10,
            }}
          >
            ◀
          </button>
          <button
            onClick={siguienteTarjeta}
            disabled={tarjetaIndex === tarjetasCliente.length - 1}
            style={{
              background: "transparent",
              border: "none",
              color: "white",
              fontSize: 20,
              cursor: tarjetaIndex === tarjetasCliente.length - 1 ? "not-allowed" : "pointer",
              marginRight: 10,
            }}
          >
            ▶
          </button>
          <button
            onClick={() => setModalPrestamo(false)}
            style={{
              background: "transparent",
              border: "none",
              color: "white",
              fontSize: 18,
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            ✕
          </button>
        </div>
      </div>

      {/* Contenido tarjeta actual */}
<div style={{ padding: 15, overflowY: "auto" }}>
  {tarjetasCliente.length === 0 ? (
    <div style={{ textAlign: "center", padding: 20, color: "#555" }}>
      Este cliente no tiene préstamos registrados
    </div>
  ) : (
    <>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <tbody>
          <Fila label="Código" value={tarjetasCliente[tarjetaIndex].id_tarjeta} />
          <Fila label="Cédula" value={clienteSeleccionado.cedula} />
      <Fila label="Fecha inicio" value={formatearFecha(tarjetasCliente[tarjetaIndex].fechainicial)} />
<Fila  label="Fecha fin" value={formatearFecha(tarjetasCliente[tarjetaIndex].fechafinal)} />
          <Fila label="Monto" value={`Bs. ${tarjetasCliente[tarjetaIndex].valor}`} />
  <Fila label="Cuotas totales" value={tarjetaActual.ncuotas} />

          <Fila label="Interés" value={`${tarjetasCliente[tarjetaIndex].interes}%`} />
          <Fila label="Valor cuota" value={`Bs. ${tarjetasCliente[tarjetaIndex].valorcuota}`} />
         <Fila label="Total abonado" value={`Bs. ${tarjetaActual.total_abonado}`} />
         <Fila
  label="Deuda"
  value={`Bs. ${tarjetaActual.deudaactual}`} // usa directamente lo que viene del backend
/>
          <Fila label="Días atraso" value={tarjetasCliente[tarjetaIndex].diasatrazo} />
          <Fila label="Comentario" value={tarjetasCliente[tarjetaIndex].detalle || "—"} />
        </tbody>
      </table>

      {/* BOTÓN VER ABONOS */}
      <div style={{ marginTop: 12, textAlign: "right" }}>
     <button
  onClick={() => setModalAbonos(true)}
  style={{
    padding: "6px 12px",
    borderRadius: 6,
    border: "none",
    background: "#0740A0",
    color: "white",
    cursor: "pointer",
  }}
>
  Ver abonos
</button>

      </div>

      {/* CASILLAS */}
   {/* CUOTAS PAGADAS */}
{/* CASILLAS: CUOTAS PAGADAS + ABONOS COMPLETOS */}
<div style={{ marginTop: 20 }}>


  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(5, 1fr)", // Ajusta según cuántas casillas quieras por fila
      gap: 6,
      marginTop: 8,
    }}
  >
    {/* Cuotas pagadas */}
    {tarjetaActual.cuotas.map((cuota, i, arr) => (
      <div
        key={cuota.id_cobro}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
   <CasillaCuota
  numero={cuota.numero}
  fecha={cuota.fecha}
  latCobro={cuota.latitud}
  lngCobro={cuota.longitud}
  latTarjeta={tarjetaActual.latitud_tarjeta}
  lngTarjeta={tarjetaActual.longitud_tarjeta}
  onClick={() => abrirModalCuota(cuota)}
/>



        {/* 🗑️ SOLO LA ÚLTIMA */}
        {i === arr.length - 1 && (
          <button
         onClick={() => confirmarEliminacion("cobro", cuota.id_cobro)}

            style={{
              marginTop: 4,
              background: "none",
              border: "none",
              color: "red",
              cursor: "pointer",
              fontSize: 14,
            }}
          >
            🗑️
          </button>
        )}
      </div>
    ))}

    {/* Abonos completos (numeración continua) */}
    {Array.from({ length: tarjetaActual.cuotas_abono || 0 }).map((_, i) => (
      <div
        key={`abono-${i}`}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Casilla
          numero={(tarjetaActual.cuotas?.length || 0) + i + 1} // Continúa la numeración
          fecha={tarjetaActual.fechainicial} // O la fecha específica del abono
        />
      </div>
    ))}
  </div>
       <button
  onClick={() => confirmarEliminacion("tarjeta", tarjetaActual.id_tarjeta)}
  style={{
    marginTop:"10px",
    padding: "6px 12px",
    borderRadius: 6,
    border: "none",
    background: "#0740A0",
    color: "white",
    cursor: "pointer",
  }}
>
  Eliminar Tarjeta
</button>
</div>
    </>
  )}
</div>
    </div>
  </div>
)}
  {/* Mapa */}
   {clienteSeleccionado?.direccionLatitud && clienteSeleccionado?.direccionLongitud ? (
        <MapContainer
          center={[
            clienteSeleccionado.direccionLatitud,
            clienteSeleccionado.direccionLongitud,
          ]}
          zoom={15}
          style={{ flex: 1, width: "100%" }} // Ocupa todo lo que queda debajo del encabezado
        >
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <Marker
            position={[
              clienteSeleccionado.direccionLatitud,
              clienteSeleccionado.direccionLongitud,
            ]}
            icon={marcadorRojo} // Marcador rojo
          />
        </MapContainer>
      ) : (
        <p></p>
      )}

      {/*MODAL DEL MENSAJE */}
{mensaje && (
  <div
    style={{
      position: "fixed",
      top: 20,
      right: 20,
      background: mensaje.tipo === "error" ? "#d32f2f" : "#2e7d32",
      color: "white",
      padding: "12px 20px",
      borderRadius: 8,
      boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
      zIndex: 6000,
    }}
  >
    {mensaje.texto}
  </div>
)}
 </div>
      {cuentasFiltradas.length === 0 && <p>No se encontraron cuentas</p>}
      
    </div>
  );
}

const th = {
  padding: "8px 10px",
  whiteSpace: "nowrap",
  textAlign: "left",
};

const td = {
  padding: "6px 10px",
  borderBottom: "1px solid #eee",
  whiteSpace: "nowrap",
};

const btn = {
  background: "white",
  border: "none",
  padding: "4px 6px",
  borderRadius: 4,
  cursor: "pointer",
};
const btn1 = {
  background: "red",
  border: "none",
  padding: "4px 6px",
  borderRadius: 4,
  cursor: "pointer",
};
// 🔧 AGREGA ESTO
const tr = {
  transition: "0.2s ease",
};
